
<mat-card>
  <mat-card-header>
    <mat-card-title class="mat-card-title-custom">
      {{'enterprise_customer_management.customer_management' | translate}}
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">

      <mat-expansion-panel expanded="true" class="mt-3"
        *ngIf="(userType !== -1 && userType !== 2) || checkDisplayFullList()">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise_customer_management.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #f="ngForm" (ngSubmit)="onFilterCustomers(0, paginate.pageSize)" class="pb-3">
          <div class="row">
            <div class="col-lg-4">
              <mat-form-field class="w-100">
                <input
                  (focusout)="customer.taxCodeOrCertificateNo = customer.taxCodeOrCertificateNo == undefined ? '' : (customer.taxCodeOrCertificateNo + '').trim()"
                  #focusInput matInput type="text"
                  [placeholder]="'enterprise_customer_management.lbl_taxCodeOrCertificateNo3' | translate"
                  name="taxCodeOrCertificateNo" [(ngModel)]="customer.taxCodeOrCertificateNo" maxlength="200"
                  autocomplete="off" />
                <button mat-button *ngIf="customer.taxCodeOrCertificateNo" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="customer.taxCodeOrCertificateNo=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-lg-4">
              <mat-form-field class="w-100">
                <input
                  (focusout)="customer.emailOrPhoneOrName = customer.emailOrPhoneOrName == undefined ? '' : (customer.emailOrPhoneOrName + '').trim()"
                  matInput type="text" [placeholder]="'enterprise_customer_management.lbl_email_phone_name' | translate"
                  name="emailOrPhoneOrName" [(ngModel)]="customer.emailOrPhoneOrName" maxlength="200"
                  autocomplete="off" />
                <button mat-button *ngIf="customer.emailOrPhoneOrName" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="customer.emailOrPhoneOrName=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-lg-4">
              <mat-form-field class="w-100">
                <mat-label>{{'enterprise_customer_management.cbx_custommer_type.lbl_custommer_type' | translate}}
                </mat-label>
                <mat-select #enterpriseTypeSelect (focusout)="(checkFocus = true)"
                  (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, enterpriseTypeSelect)" id="types" name="types"
                  [(ngModel)]="customer.enterpriseTypeId" (ngModelChange)="onFilterCustomers(0, paginate.pageSize)">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="enterpriseTypeFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option value="null" mat-selected
                    (click)="this.commonService.closeDropdownList(this.enterpriseTypeSelect)">
                    {{'form.select' | translate}}</mat-option>
                  <mat-option *ngFor="let enterpirse of filteredEnterpriseType | async" value={{enterpirse.id}}
                    (click)="this.commonService.closeDropdownList(this.enterpriseTypeSelect)"
                    title="{{getEnterpriseTypeOptions(enterpirse.langs) }}">
                    {{getEnterpriseTypeOptions(enterpirse.langs)}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <!-- Mã khách hàng -->
            <ng-container *ngIf="!isBasicSearchForm" class="row col-lg-12">
              <!-- <div class="col-lg-4">
                <mat-form-field class="w-100">
                  <input (focusout)="cutSpace()"
                    #focusInput matInput type="text"
                    [placeholder]="'headertable.customer_code' | translate"
                    name="customerCode" [(ngModel)]="customer.customerCode"
                    autocomplete="off" />
                  <button mat-button *ngIf="customer.customerCode" type="button" matSuffix mat-icon-button aria-label="Clear"
                          (click)="customer.customerCode=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div> -->
                <div class="col-lg-8">
              <mat-form-field class="w-100">
                <mat-label>{{'form.group_customer' | translate}}</mat-label>
                <mat-select #groupSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, groupSelect)" id="group" name="group"
                  [(ngModel)]="group.id" [multiple]="true">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate" [formControl]="GroupCustomersFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option #allSelectedGroup (click)="clickOptionServiceTypeAll()">
                    {{ 'form.select_all_group' | translate }}
                  </mat-option>

                  <mat-option *ngFor="let group of filteredGroupCustomers | async" [value]="group.id"
                    [matTooltip]="group.name" (click)="clickOptionServiceType()">
                    {{group.name}}
                  </mat-option>
                  <mat-option [value]="'0'" (click)="clickOptionServiceType()">
                    {{ 'form.unselect_group' | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </ng-container>
            <!-- button up/down -->
            <div class="col-lg-12 col-md-6 d-flex justify-content-end">
              <button *ngIf="!isBasicSearchForm" type="button" mat-button class="advance-search"
                (click)="onCloseAdvancedSearchForm()">
                <span>{{'enterprise_contract.buttons.basic' | translate}}</span>
                <em class="material-icons">keyboard_arrow_up</em>
              </button>
              <button *ngIf="isBasicSearchForm" type="button" mat-button class="advance-search"
                (click)="onExpandAdvancedSearchForm()">
                <span>{{'enterprise_contract.buttons.advance' | translate}}</span>
                <em class="material-icons">keyboard_arrow_down</em>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 d-flex justify-content-center">
              <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()" appTrackEvent="w.btn.danh_sach_kh.tim_kiem" [disabled]="isTableLoading">
                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                {{'enterprise_customer_management.buttons.search' | translate}}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
      <mat-expansion-panel expanded="true" *ngIf="userType == 2 && !checkDisplayFullList()">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise_customer_management.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #f="ngForm" (ngSubmit)="onFilterCustomers(0, paginate.pageSize)">
          <div class="row">
            <div class="col-lg-4 d-flex justify-content-center">
              <mat-form-field class="w-100">
                <input #focusInput matInput type="text"
                  (focusout)="customer.taxCodeOrCertificate = customer.taxCodeOrCertificate.trim()"
                  [placeholder]="'enterprise_customer_management.lbl_taxCodeOrCertificateNo3' | translate"
                  name="taxCodeOrCertificate" [(ngModel)]="customer.taxCodeOrCertificate" maxlength="200"
                  autocomplete="off" />
                <button mat-button *ngIf="customer.taxCodeOrCertificate" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="customer.taxCodeOrCertificate=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
            <div class="col-lg-4 d-flex justify-content-center">
              <div class="w-100 center-vertical">
                <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()" appTrackEvent="w.btn.danh_sach_kh.tim_kiem" [disabled]="isTableLoading">
                  <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                  {{'enterprise_customer_management.buttons.search' | translate}}
                </button>
              </div>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <!-- Danh sách khách hàng -->
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
          <span *ngIf="!commonService.getIsLockedEnterprise()">{{'enterprise_customer_management.list_customer' |
            translate}}
            ({{paginate.totalRow}}), {{'enterprise_customer_management.selected' | translate}}
            {{this.dataSelected.size}}
          </span>
          <span *ngIf="commonService.getIsLockedEnterprise()">{{'enterprise_customer_management.list_customer' |
            translate}}
            ({{paginate.totalRow}})
          </span>

          <div class="mb-2"
            style="min-width: 300px; display: flex; justify-content: flex-end; position: absolute; right: 24px;">
            <button mat-stroked-button color="primary" type="button" (click)="openDialogSync()"  appTrackEvent="w.btn.danh_sach_kh.dong_bo"
              *ngIf="!(mediaBreakpoint === SCREEN_SIZE.XS || mediaBreakpoint === SCREEN_SIZE.SM) && ((isBuyTwoService && isDefaultAdmin))">
              <mat-icon class="mr-0">refresh</mat-icon>
              {{'button.synchronized' | translate}}
              {{'notify.from' | translate}}
              <span *ngIf="!isNotAttestedUser">sContract</span>
              <span *ngIf="isNotAttestedUser">vContract</span>
            </button>
            <button *ngIf="checkDisplayBtnAddCustomer()" mat-stroked-button color="primary" class="ml-1" (click)="onImportFile()" appTrackEvent="w.btn.danh_sach_kh.them_tu_file"
              [disabled]="commonService.getIsLockedEnterprise()">
              <mat-icon class="mr-0">folder</mat-icon> {{'enterprise_customer_management.add_from_file' | translate}}
            </button>
            <button *ngIf="checkDisplayBtnAddCustomer()" mat-stroked-button color="primary" class="ml-1" (click)="checkNavCus()" appTrackEvent="w.btn.danh_sach_kh.them_moi"
              [disabled]="commonService.getIsLockedEnterprise()">
              <mat-icon class="mr-0">add_circle</mat-icon>{{'enterprise_customer_management.buttons.add' | translate}}
            </button>
            <!-- <button *ngIf="userType == 1 || (userType == 2 && permissions.includes(4))"
              mat-stroked-button color="primary" type="button"class="ml-1"
              [disabled]="this.dataSelected.size === 0 || this.dataSource === null || this.dataSource.data === null || this.dataSource.data.length === 0 || commonService.getIsLockedEnterprise()"
              [matMenuTriggerFor]="menuFeature">
              <mat-icon>more_vert</mat-icon>
              {{'button.more_feature' | translate}}
              </button> -->
            <button *ngIf="userType == 1 || (userType == 2 && checkDisplayBtnMore())" mat-stroked-button appTrackEvent="w.btn.danh_sach_kh.khac"
              color="primary" class="ml-1 custom-button-icon" type="button"
              [disabled]="this.dataSelected.size === 0 || this.dataSource === null || this.dataSource.data === null || this.dataSource.data.length === 0 || commonService.getIsLockedEnterprise()"
              [matTooltip]="'button.more_feature' | translate" [matMenuTriggerFor]="menuFeature">
              <mat-icon class="mr-0">more_vert</mat-icon>
            </button>
          </div>

          <!-- menu -->
          <mat-menu #menuFeature="matMenu">

            <button *ngIf="checkDisplayBtnExportCustomer()" mat-menu-item style="border-bottom: 1px solid rgb(213 213 213) !important;" appTrackEvent="w.btn.danh_sach_kh.khac.xuat_day_du"
              (click)="exportData(true)" class="other-button">
              {{'enterprise_contract.buttons.export_data_customer_full' | translate}}
            </button>

            <button *ngIf="checkDisplayBtnExportCustomer()" mat-menu-item style="border-bottom: 1px solid rgb(213 213 213) !important;" appTrackEvent="w.btn.danh_sach_kh.khac.xuat_rut_gon"
              (click)="exportData(false)" class="other-button">
              {{'enterprise_contract.buttons.export_data_customer_compact' | translate}}
            </button>

            <button *ngIf="checkDisplayBtnAssignGroup()" mat-menu-item style="border-bottom: 1px solid rgb(213 213 213) !important;" (click)="assignGroup()" appTrackEvent="w.btn.danh_sach_kh.khac.gan_nhom_kh"
              class="other-button">
              {{'button.assign_group' | translate}}
            </button>

            <button *ngIf="checkDisplayBtnAssignGroup()" mat-menu-item style="border-bottom: 1px solid rgb(213 213 213) !important;" appTrackEvent="w.btn.danh_sach_kh.khac.bo_gan_nhom_kh"
              (click)="removeAssignGroup()" class="other-button">
              {{'button.remove_assign_group' | translate}}
            </button>

            <button *ngIf="checkDisplayBtnDeleteLotCustomer()" mat-menu-item style="border-bottom: 1px solid rgb(213 213 213) !important;" appTrackEvent="w.btn.danh_sach_kh.khac.xoa"
              (click)="deleteAll(this.dataSelected.size)" class="other-button">
              {{'button.delete' | translate}}
            </button>
          </mat-menu>
        </mat-panel-title>
        <div class="mat-table-container">
          <mat-table [dataSource]="dataSource" width="100%">
            <!-- check-->
            <ng-container matColumnDef="check">
              <mat-header-cell *matHeaderCellDef
                class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                <mat-checkbox [disabled]="commonService.getIsLockedEnterprise()"
                  *ngIf="dataSource && dataSource.data && dataSource.data.length > 0" [(ngModel)]="checkAll"
                  (change)="checkAllDocument()" color="primary"></mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                (click)="$event.stopPropagation()">
                <mat-checkbox color="primary" [(ngModel)]="element.checked" (change)="onSelectionChange(element)"
                  [disabled]="commonService.getIsLockedEnterprise()">
                </mat-checkbox>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell check-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>
            <!-- STT -->
            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_customer_management.table_headers.No' | translate}}</mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{paginate.no[dataSource.filteredData.indexOf(element)]}}</mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Mã khách hàng -->
            <ng-container matColumnDef="customerCode">
              <mat-header-cell *matHeaderCellDef style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                {{'headertable.customer_code' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{element.customerCode}}" matTooltipPosition="below"
                        style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{element.customerCode}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tên khách hàng -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                {{'enterprise_customer_management.table_headers.customer_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{element.name}}" matTooltipPosition="below"
                        style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{element.name}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tên khách hàng -->
            <ng-container matColumnDef="groupName">
              <mat-header-cell *matHeaderCellDef style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                {{'enterprise_customer_management.table_headers.group_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{element.customerGroupNames}}" matTooltipPosition="below"
                style="width: 20%;" class="mat-cell-non-boder-right-bottom">
                <span class="fix-width">{{element.customerGroupNames}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- MST/CMTND/Số giấy tờ -->
            <ng-container matColumnDef="certificateNo">
              <mat-header-cell *matHeaderCellDef style="max-width: 25%;" class="mat-cell-non-boder-right-bottom">
                {{'enterprise_customer_management.table_headers.taxCodeOrCertificateNo' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 25%;"
                class="mat-cell-non-boder-right-bottom number-cell-right"
                matTooltip="{{element.customerType == personalId ? element.certificateNo : element.taxCode != null ? element.taxCode : element.certificateNo}}">
                <span class="fix-width">{{element.customerType == personalId ? element.certificateNo : element.taxCode
                  != null ? element.taxCode : element.certificateNo}}
                </span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 25%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Địa chỉ -->
            <ng-container matColumnDef="address">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-cell-non-boder-right-bottom">
                {{'enterprise_customer_management.table_headers.address' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 20%;" class="mat-cell-non-boder-right-bottom"
                matTooltip="{{element.address}}">
                <span class="fix-width">{{element.address}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Email -->
            <ng-container matColumnDef="email">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%;" class="mat-cell-non-boder-right-bottom">
                {{'enterprise_customer_management.table_headers.email' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 20%;" class="mat-cell-non-boder-right-bottom"
                matTooltip="{{element.email}}">
                <span class="fix-width">{{element.email}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Số điện thoại -->
            <ng-container matColumnDef="phone">
              <mat-header-cell *matHeaderCellDef style="max-width: 110px" class="mat-cell-non-boder-right-bottom">
                {{'enterprise_customer_management.table_headers.phone' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 110px"
                class="mat-cell-non-boder-right-bottom number-cell-center">
                <span class="fix-width">{{element.phone}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 110px">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Loại khách hàng  -->
            <ng-container matColumnDef="customerType">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%;">
                {{'enterprise_customer_management.table_headers.customer_type' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" style="max-width: 20%;"
                matTooltip="{{enterpriseTypeI18n.get(element.customerType) | translate}}">
                <span class="fix-width">{{enterpriseTypeI18n.get(element.customerType) | translate}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tác động -->
            <!-- Setting Column -->
            <ng-container matColumnDef="action" class="mat-column-symbol">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-bottom"
                style="max-width: 140px;">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-bottom"
                style="max-width: 140px;">
                <button mat-icon-button (click)="onClickBtnViewUpdate('/home-enterprise/view-customer/', element.id)" appTrackEvent="w.btn.danh_sach_kh.xem_chi_tiet">
                  <mat-icon matTooltip="{{'enterprise_customer_management.buttons.view' | translate}}">visibility
                  </mat-icon>
                </button>
                <button mat-icon-button (click)="onClickBtnViewUpdate('/home-enterprise/update-customer/', element.id)"
                  [disabled]="commonService.getIsLockedEnterprise()"
                  *ngIf="((userType !== -1 && userType !== 2) || checkDisplayBtnUpdateOrDeleteCustomer(element))" appTrackEvent="w.btn.danh_sach_kh.cap_nhat">
                  <mat-icon matTooltip="{{'enterprise_customer_management.buttons.edit' | translate}}">edit</mat-icon>
                </button>
                <button mat-icon-button (click)="onClickIconDelete(element.id,element.name)"  appTrackEvent="w.btn.danh_sach_kh.xoa"
                  [disabled]="commonService.getIsLockedEnterprise()"
                  *ngIf="(userType !== -1 && userType !== 2) || checkDisplayBtnUpdateOrDeleteCustomer(element)">
                  <!-- <mat-icon matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}">delete_forever
                  </mat-icon> -->
                  <i class="fa fa-trash" aria-hidden="true" [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise()}"
                    matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}"></i>
                </button>
                <!-- <button mat-icon-button (click)="onClickIconDelete(element.id,element.name)"
                  [disabled]="commonService.getIsLockedEnterprise()"
                  *ngIf="((userType !== -1 && userType !== 2) || permissions.includes(4)) && (element.hasPermission)">
                  <i class="fa fa-trash" aria-hidden="true"
                    [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise()}"
                    matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}"></i>
                </button> -->
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 140px;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                 ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng theo dung cot;
                 an/hien qua class theo isTableLoading -->
            <mat-footer-row *matFooterRowDef="displayedColumns"
                            class="table-skeleton-row"
                            [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
          </mat-table>
          </div>
        <div class="py-4" *ngIf="error">
          <div class="card">
            <p class="card-body text-danger" style="white-space: pre-wrap; padding-bottom: 0;">{{error}}</p>
          </div>
        </div>
        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="onFilterCustomers($event.page, $event.pageSize)"
                        [isShowNoRecord]="!isTableLoading">
        </app-pagination>
        <!-- /Pagination -->
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>
